import { ModalHeader as ModalHeader$1, ModalBody as ModalBody$1, ModalFooter as ModalFooter$1 } from 'baseui/modal';
import 'react/jsx-runtime';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { withStyle } from '../../theme/utils.js';
import '../../theme/types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ModalHeader = withStyle(ModalHeader$1, ({ $theme }) => __spreadProps(__spreadValues({}, $theme.typography.h4), {
  marginTop: $theme.space[24],
  marginRight: $theme.space[32],
  marginBottom: $theme.space[24],
  marginLeft: $theme.space[24]
}));
const ModalBody = withStyle(ModalBody$1, ({ $theme }) => ({
  marginTop: $theme.space[24],
  marginRight: $theme.space[24],
  marginBottom: $theme.space[24],
  marginLeft: $theme.space[24],
  ":first-child": {
    marginTop: $theme.space[48]
  }
}));
const ModalFooter = withStyle(ModalFooter$1, ({ $theme }) => ({
  display: "flex",
  justifyContent: "center",
  gap: $theme.space[16],
  marginTop: $theme.space[24],
  marginRight: $theme.space[24],
  marginBottom: $theme.space[24],
  marginLeft: $theme.space[24],
  paddingTop: 0,
  paddingBottom: 0,
  textAlign: "center"
}));

export { ModalBody, ModalFooter, ModalHeader };
